import React from "react";
import { HeaderContainer } from "./index.styled";

interface CardHeaderProps {
  title: string;
}

const CardHeader: React.FC<CardHeaderProps> = ({ title }) => {
  return (
    <HeaderContainer>
      <div className="title">{title}</div>
    </HeaderContainer>
  );
};

export default CardHeader;
